import axios from "axios";

const API_BASE_URL =
  import.meta?.env?.VITE_API_URL ||
  process.env.REACT_APP_API_URL ||
  "https://graficosb-production.up.railway.app";

const API = `${API_BASE_URL}/api/educacion`;
const opts = { timeout: 60000 };

export async function fetchResumen() {
  const { data } = await axios.get(`${API}/matricula/resumen`, opts);
  return data;
}
export async function fetchSeries() {
  const { data } = await axios.get(`${API}/series`, opts);
  return data;
}
export async function fetchSexo() {
  const { data } = await axios.get(`${API}/sexo`, opts);
  return data;
}
